import { useEffect } from 'react';
import { useAuth } from './AuthContext';

/**
 * Applica le preferenze di accessibilità dell'utente come classi sul root:
 * il CSS globale (styles/index.css) reagisce a .a11y-high-contrast,
 * .a11y-reduce-motion, .a11y-large-text, .a11y-simplified.
 * Le preferenze OS (prefers-reduced-motion, prefers-contrast) restano
 * comunque rispettate: queste sono IN AGGIUNTA.
 */
export function A11yEffect() {
  const { user } = useAuth();

  useEffect(() => {
    const prefs = (user?.a11yPreferences ?? {}) as Record<string, boolean>;
    const root = document.documentElement;
    root.classList.toggle('a11y-high-contrast', !!prefs.highContrast);
    root.classList.toggle('a11y-reduce-motion', !!prefs.reduceMotion);
    root.classList.toggle('a11y-large-text', !!prefs.largeText);
    root.classList.toggle('a11y-simplified', !!prefs.simplifiedUi);
    root.classList.toggle('a11y-screen-reader', !!prefs.screenReaderMode);
  }, [user]);

  return null;
}
